module.exports = __webpack_public_path__ + "static/img/resolvent5.e6426b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/resolvent5.png
// module id = kL6i
// module chunks = 13